import { parse, isValid, format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function formattedDatePtBrToIso(value: string) {
  if (!value) return ''

  const dateTime = parse(value, 'dd/MM/yyyy HH:mm', new Date(), { locale: ptBR })

  if (isValid(dateTime)) {
    return format(dateTime, "yyyy-MM-dd'T'HH:mm:ss")
  }

  const dateOnly = parse(value, 'dd/MM/yyyy', new Date(), { locale: ptBR })

  if (isValid(dateOnly)) {
    return format(dateOnly, 'yyyy-MM-dd')
  }

  return ''
}
